import { Tool } from '../containers/plans/types';
import {api} from './api';

export const toolsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getToolOptions: builder.query<Tool[], void>({
			query: () => ({
				url: 'tools/findOptions',
				method: 'GET',
			}),
		}),
		getCompanyTools: builder.query<Tool[], void>({
			query: () => ({
				url: 'tools/findCompanyOwn',
				method: 'GET',
			}),
			extraOptions: { maxRetries: 1 }
		}),
		addCompanyTool: builder.mutation<Tool, number>({
			query: (toolId) => ({
				url: 'tools/addToCompany',
				method: 'POST',
				body: { toolId },
			}),
		}),
		removeCompanyTool: builder.mutation<Pick<Tool, 'id'>, number>({
			query: (toolId) => ({
				url: `tools/removeFromCompany/${toolId}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const { useGetCompanyToolsQuery, useAddCompanyToolMutation, useRemoveCompanyToolMutation, useGetToolOptionsQuery } = toolsApi;
